// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3A80I","title":"styles_title__2Mgb7"};